import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';

import { StructureDto } from '../../../shared/models/structure.dto';
import { StructureService } from '../../../shared/services/structure.service';
import { StructureSupportPlacesComponent } from './structure-support-places/structure-support-places.component';
import { StructureAddressComponent } from './structure-address/structure-address.component';
import { StructureGlobalComponent } from './structure-global/structure-global.component';

@Component({
  selector: 'app-admin-structure-details',
  templateUrl: './structure-details.component.html',
})
export class StructureDetailsComponent implements OnInit {
  public structure: StructureDto;
  public submitted: boolean = false;
  public isModificationMode: boolean = false;

  public activeTabId: string = 'global';

  @ViewChild(StructureGlobalComponent) public structureDetailGlobal: StructureGlobalComponent;
  @ViewChild(StructureAddressComponent) public structureDetailAddress: StructureAddressComponent;
  @ViewChild(StructureSupportPlacesComponent) public structureDetailSupportPlace: StructureSupportPlacesComponent;

  private structureId: number;

  constructor(public readonly modal: NgbActiveModal, private readonly structureService: StructureService) {}

  public onInit(structureId?: number): void {
    this.structureId = structureId;
    this.isModificationMode = !!structureId;
  }

  public async ngOnInit(): Promise<void> {
    await this.loadForm();
  }

  private async loadForm(): Promise<void> {
    if (this.isModificationMode) {
      this.structure = await this.structureService.findById(this.structureId);
    } else {
      this.structure = new StructureDto();
    }

    if (!this.structure) {
      throw new Error('Impossible de charger les données pour la structure demandée.');
    }
  }

  public async onSubmit(): Promise<void> {
    this.submitted = true;
    const validStructureDetailGlobal: boolean = this.structureDetailGlobal.onSubmit();
    const validStructureDetailAddress: boolean = this.structureDetailAddress.onSubmit();
    const validStructureDetailSupportPlace: boolean = this.structureDetailSupportPlace.onSubmit();

    if (validStructureDetailGlobal && validStructureDetailAddress && validStructureDetailSupportPlace) {
      if (this.structure) {
        if (!this.isModificationMode) {
          // create
          await this.structureService.createStructure(this.structure);
        } else {
          // update
          await this.structureService.updateStructure(this.structure);
        }
      }
      this.modal.close();
    }
  }

  public cancel(): void {
    this.modal.close();
  }

  public onNavChange(event: NgbNavChangeEvent): void {
    this.activeTabId = event.nextId;
  }
}
